module.exports = __webpack_public_path__ + "static/media/extrasupport.cb5ee8a0.jpg";